<template>
    <div>
        <div class="loading" v-if="loading">
            <van-loading size="0.64rem" color="var(--grey)" />
        </div>
        <div class="header">
            <van-notice-bar
                color="var(--primary)"
                background="#d2f1f0"
                left-icon="info-o"
            >{{noticeText}}</van-notice-bar>
        </div>
        <div class="report-user-info">
            <van-row class="report-row" v-if="reportDetail.reportName">
                <van-col span="24">
                    <div>报告名称: {{reportDetail.reportName}}</div>
                </van-col>
            </van-row>
            <van-row class="report-row">
                <van-col span="8">
                    <div>姓名: {{reportDetail.patName}}</div>
                </van-col>
                <van-col span="8">
                    <div>性别: {{reportDetail.patGender}}</div>
                </van-col>
                <van-col span="8">
                    <div>年龄: {{reportDetail.patAge}}</div>
                </van-col>
            </van-row>
            <van-row class="report-row">
                <van-col span="16">
                    <div>开单科室: {{reportDetail.depName}}</div>
                </van-col>
                <van-col span="8">
                    <div>开单医生: {{reportDetail.docName}}</div>
                </van-col>
            </van-row>
            <van-row class="report-row">
                <van-col span="24">
                    <div>检查部位: {{reportDetail.inspectionArea}}</div>
                </van-col>
            </van-row>
            <van-row class="report-row">
                <van-col span="24">
                    <div>报告医生: {{reportDetail.reportDocName}}</div>
                </van-col>
            </van-row>
            <van-row class="report-row">
                <van-col span="16">
                    <div>报告时间: {{reportDetail.reportTime}}</div>
                </van-col>
                <van-col span="8">
                    <div>报告录入: {{reportDetail.reportEntryName}}</div>
                </van-col>
            </van-row>
        </div>
                
        <div class="report-detail-info">
            <van-row class="report-content">
                <van-col span="4" style="padding: 0rem;">影像结论:</van-col>
                <van-col span="20">
                    <pre>{{reportDetail.imageConclusion}}</pre>
                </van-col>
            </van-row>
            <van-row class="report-content">
                <van-col span="4" style="padding: 0rem;">检查结论:</van-col>
                <van-col span="20">
                    <pre>{{reportDetail.inspectionConclusion}}</pre>
                </van-col>
            </van-row>
        </div>   
    </div>
</template>

<script>
import manageApi from '@/api/manageApi';

export default {
    data() {
        return {
            loading: false,
            schedLoading: false,
            reportDetail: {
                reportName: '超声医学影像报告单',
                patName: '李治',
                patGender: '男',
                patAge: '25',
                depName: '门诊',
                docName: '刘睿',
                specimen: '',
                reportDocName: '刘睿',
                reportTime: '2024-06-03 08:09',
                reportEntryName: '刘睿',
                inspectionArea: '肝胆胰脾肾输尿管膀胱',
                imageConclusion:'肝脏：肝脏大小正常，边界清楚,外形规则，肝缘锐利,表面光滑,实质回声均匀,分布均匀。肝内管道走形清晰，彩色多普勒未见异常。\n'+
                '胆囊：大小约6.9*3.Ocm，形态正常，胆毒壁光滑，胆囊内未见异常回声。胆总管：内径0.6cm，内径均匀，内部液区清晰，肝内胆管：左右叶未见异常。\n'+
                '胰腺：胰腺大小正常，内中等回声，分布均匀，形态规则。\n'+
                '脾脏：大小形态正常，边界清楚，外形规则，实质回声暗淡，分布均匀，脾门清晰可见。\n'+
                '肾脏：双肾大小正常，边界清楚，外形规则，实质回声暗淡均匀，双肾集合系统分离，呈无回声暗区，宽约1.5cm(左)1.4cm(右)。双肾内探及多个强回声伴声影，最大直径约1.5cm。\n'+
                '输尿管：双侧输尿管上段探及强回声光团后方伴声影，大小分别为1.3*0.6cm（左)1.0*0.6cm（右）。\n'+
                '膀胱：膀肤充盈好，壁连续，其内未见异常回声。',
                inspectionConclusion: '双肾结石\n双肾积水\n双侧输尿管结石'
            },
            noticeText: '此检查报告仅供参考，不作为任何医学凭据，请以医院最终的报告单数据为准。若对检查结果有任何疑问，请直接到医院进行查询打印，检查结果临床意义请咨询相关医生！',
        }
    },
    created() {
        
    },
    methods: {
        
    },
    props: {
        id: {
            type: String,
            required: false
        }
    }
}
</script>


<style lang="less" scoped>
.loading {
    text-align: center;
}
.report-user-info {
    font-size: 0.35rem;
    margin-top: -0.13rem;
    background-color: var(--white);
}

.report-user-info .report-row {
    margin: 0.13rem 0.41rem 0rem 0.41rem;
    padding: 0.27rem 0rem;
    border-bottom: 0.01rem solid rgba(0, 0, 0, 0.1);
}

.report-detail-info .report-content {
    font-size: 0.35rem;
    background-color: var(--white);
    padding: 0.27rem 0.41rem;
    border-bottom: 0.01rem solid rgba(0, 0, 0, 0.1);
}

.report-detail-info .report-content:last-child {
    border: none;
}

.report-detail-info .report-content div {
    padding: 0rem 0.1rem;
}

.report-detail-info pre {
    font-size: 0.35rem;
    white-space: pre-wrap;
    /* css3.0 */
    white-space: -moz-pre-wrap;
    /* Firefox */
    white-space: -pre-wrap;
    /* Opera 4-6 */
    white-space: -o-pre-wrap;
    /* Opera 7 */
    word-wrap: break-word;
    /* Internet Explorer 5.5+ */
}
</style>